import React from 'react';
import { Link } from 'react-router-dom';

const ClassificationChart = ({ title, players = [], onPlayAll }) => {

    const handlePlayAllClick = (e) => {
        e.preventDefault();
        if (onPlayAll) {
            onPlayAll(title, players);
        } else {
            console.warn(`Play All functionality not implemented for ${title}`);
        }
    }

    return (
        // Card itself just defines the background and shadow, takes full height
        <div className="card bg-base-100 shadow-xl h-full">
            {/* Make card-body the flex container that fills height */}
            <div className="card-body p-4 md:p-5 h-full flex flex-col">

                {/* Header content (Title/Button) - Should not grow/shrink */}
                <div className="flex-shrink-0 mb-3"> {/* Added margin-bottom */}
                    <div className="flex justify-between items-center">
                        <h2 className="card-title text-base md:text-lg line-clamp-1">{title}</h2>
                        <button
                            className="btn btn-ghost btn-xs"
                            onClick={handlePlayAllClick}
                            disabled={!players || players.length === 0}
                        >
                            Play All ▶
                        </button>
                    </div>
                </div>

                {/* Player List Container - Should grow and scroll */}
                {/* flex-grow makes it take remaining space, overflow-auto handles scrolling */}
                {/* Added min-h-0 to prevent potential flexbox overflow issues */}
                <div className="flex-grow overflow-auto min-h-0">
                    {players && players.length > 0 ? (
                        <ul className="space-y-2 text-sm">
                            {/* Header Row */}
                            <li className="flex justify-between font-semibold text-base-content text-opacity-70 border-b border-base-300 pb-1 mb-2 text-xs sticky top-0 bg-base-100 z-[1]">
                                {/* Added sticky header within the scrollable area */}
                                <span>Name</span>
                                <span>Total</span>
                            </li>
                            {/* Player Rows */}
                            {players.map((player) => (
                                <li key={player.player_id} className="flex justify-between items-center group">
                                    <Link to={`/player/${player.player_id}`} className="hover:text-primary transition-colors duration-200 truncate mr-2 flex-grow min-w-0">
                                        <span className="font-medium block truncate">{player.name}</span>
                                        <span className="text-xs opacity-60 block"> {player.position} {player.team_abbr} </span>
                                    </Link>
                                    <span className="font-semibold text-accent flex-shrink-0 ml-2"> {player.snippet_count} </span>
                                </li>
                            ))}
                        </ul>
                    ) : (
                        // No players message - align it center within the growable area
                        <div className="flex items-center justify-center h-full">
                             <p className="text-base-content text-opacity-60 text-center text-sm italic">
                                 No top players found for this period/filter.
                             </p>
                         </div>
                    )}
                </div> {/* End Player List Container */}

            </div> {/* End Card Body */}
        </div> // End Card
    );
};

export default ClassificationChart;